import { render } from "./GroupsView.vue?vue&type=template&id=55b7e7da"
import script from "./GroupsView.vue?vue&type=script&lang=js"
export * from "./GroupsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__